import { tracked } from "@glimmer/tracking";
import Controller from "@ember/controller";
import { action, computed } from "@ember/object";
import { ajax } from "discourse/lib/ajax";
import getURL from "discourse/lib/get-url";
import NameValidationHelper from "discourse/lib/name-validation-helper";
import PasswordValidationHelper from "discourse/lib/password-validation-helper";
import DiscourseURL, { userPath } from "discourse/lib/url";
import { wavingHandURL } from "discourse/lib/waving-hand-url";
import { i18n } from "discourse-i18n";

export default class AdminInvite extends Controller {
  @tracked accountPassword;
  @tracked accountUsername;
  @tracked accountName;
  @tracked usernameError;
  maskPassword = true;
  passwordRequired = true; // used by the password validation helper
  redirected = false;

  lastAttemptedUsername;
  nameValidationHelper = new NameValidationHelper(this);
  passwordValidationHelper = new PasswordValidationHelper(this);

  get admin() {
    return this.model?.admin;
  }

  get submitDisabled() {
    return (
      this.passwordValidation.failed ||
      this.nameValidation.failed ||
      this.usernameErrorMessage
    );
  }

  get nameValidation() {
    return this.nameValidationHelper.nameValidation;
  }

  get passwordValidation() {
    return this.passwordValidationHelper.passwordValidation;
  }

  get usernameErrorMessage() {
    if (
      this.usernameError &&
      this.accountUsername === this.lastAttemptedUsername
    ) {
      return this.usernameError;
    }
  }

  @computed()
  get wavingHandURL() {
    return wavingHandURL();
  }

  @computed
  get welcomeTitle() {
    return i18n("invites.welcome_to", {
      site_name: this.siteSettings.title,
    });
  }

  @computed("model.email")
  get yourEmailMessage() {
    return i18n("admin_invite.your_email", { email: this.model?.email });
  }

  @computed("redirectTo")
  get redirectHref() {
    return getURL(this.redirectTo || "/");
  }

  @action
  togglePasswordMask() {
    this.toggleProperty("maskPassword");
  }

  @action
  async submit() {
    this.lastAttemptedUsername = this.accountUsername;

    const result = await ajax({
      url: userPath(`admin-invite/${this.get("model.token")}.json`),
      type: "PUT",
      data: {
        username: this.accountUsername,
        name: this.accountName,
        password: this.accountPassword,
        timezone: moment.tz.guess(),
      },
    });

    if (result.success) {
      this.set("redirectTo", result.redirect_to);
      this.set("redirected", true);
      DiscourseURL.redirectTo(this.redirectHref);
    } else {
      if (
        result.errors &&
        result.errors["user_password.password"] &&
        result.errors["user_password.password"].length > 0
      ) {
        this.passwordValidationHelper.rejectedPasswords.push(
          this.accountPassword
        );
        this.passwordValidationHelper.rejectedPasswordsMessages.set(
          this.accountPassword,
          result.errors["user_password.password"][0]
        );
      }
      if (
        result.errors &&
        result.errors.username &&
        result.errors.username.length > 0
      ) {
        this.usernameError = result.errors.username[0];
      }
    }
  }
}
